/*
 * Profile Messages
 *
 * This contains all the text for the Profile container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Profile';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Profile',
  },
  saveBtn: {
    id: `${scope}.saveBtn`,
    defaultMessage: 'Save changes',
  },
  firstName: {
    id: `${scope}.firstName`,
    defaultMessage: 'First Name',
  },
  lastName: {
    id: `${scope}.lastName`,
    defaultMessage: 'Last Name',
  },
  country: {
    id: `${scope}.country`,
    defaultMessage: 'Country',
  },
  pid: {
    id: `${scope}.pid`,
    defaultMessage: 'PID',
  },
  fid: {
    id: `${scope}.fid`,
    defaultMessage: 'FID',
  },
  sport: {
    id: `${scope}.sport`,
    defaultMessage: 'Sport',
  },
  position: {
    id: `${scope}.position`,
    defaultMessage: 'Position',
  },
  sex: {
    id: `${scope}.sex`,
    defaultMessage: 'Sex',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  mobile: {
    id: `${scope}.mobile`,
    defaultMessage: 'Mobile',
  },
  opt: {
    id: `${scope}.opt`,
    defaultMessage: 'country code, number',
  },
  changePass: {
    id: `${scope}.changePass`,
    defaultMessage: 'Change password',
  },
  birth: {
    id: `${scope}.birth`,
    defaultMessage: 'Birth',
  },
  details: {
    id: `${scope}.details`,
    defaultMessage: 'Details',
  },
  dominantArm: {
    id: `${scope}.dominantArm`,
    defaultMessage: 'Dominant Arm',
  },
  dominantLeg: {
    id: `${scope}.dominantLeg`,
    defaultMessage: 'Dominant Leg',
  },
  age: {
    id: `${scope}.age`,
    defaultMessage: 'Age',
  },
  kg: {
    id: `${scope}.kg`,
    defaultMessage: 'kg',
  },
  lbs: {
    id: `${scope}.lbs`,
    defaultMessage: 'lbs',
  },
  cm: {
    id: `${scope}.cm`,
    defaultMessage: 'cm',
  },
  inc: {
    id: `${scope}.inc`,
    defaultMessage: 'inc',
  },
  updated: {
    id: `${scope}.updated`,
    defaultMessage: 'Updated',
  },
  bmi: {
    id: `${scope}.bmi`,
    defaultMessage: 'BMI',
  },
  male: {
    id: `${scope}.male`,
    defaultMessage: 'Male',
  },
  female: {
    id: `${scope}.female`,
    defaultMessage: 'Female',
  },
  left: {
    id: `${scope}.left`,
    defaultMessage: 'Left',
  },
  right: {
    id: `${scope}.right`,
    defaultMessage: 'Right',
  },
  uploadPhoto: {
    id: `${scope}.uploadPhoto`,
    defaultMessage: 'Upload a photo',
  },
  bodyWeight: {
    id: `${scope}.bodyWeight`,
    defaultMessage: 'Body weight',
  },
  height: {
    id: `${scope}.height`,
    defaultMessage: 'Height',
  },
  maxSize: {
    id: `${scope}.maxSize`,
    defaultMessage: 'Maximum file size 100 KB',
  },
});
